// src/components/BottomNav.tsx
import { LayoutDashboard, Inbox, Zap, BarChart2, Users, Settings } from 'lucide-react'

type Page = 'dashboard' | 'inbox' | 'triage' | 'review' | 'squad' | 'settings'

interface BottomNavProps {
  page: Page
  onNavigate: (page: Page) => void
}

const TABS: Array<{ id: Page; icon: React.ReactNode; label: string }> = [
  { id: 'dashboard', icon: <LayoutDashboard size={20} />, label: 'Home' },
  { id: 'inbox',     icon: <Inbox size={20} />,           label: 'Inbox' },
  { id: 'triage',   icon: <Zap size={20} />,             label: 'Triage' },
  { id: 'review',   icon: <BarChart2 size={20} />,        label: 'Review' },
  { id: 'squad',    icon: <Users size={20} />,            label: 'Squad' },
  { id: 'settings', icon: <Settings size={20} />,         label: 'Settings' },
]

export function BottomNav({ page, onNavigate }: BottomNavProps) {
  return (
    <nav className="bottom-nav">
      {TABS.map(tab => (
        <button
          key={tab.id}
          id={`nav-${tab.id}`}
          className={`nav-item ${page === tab.id ? 'active' : ''}`}
          onClick={() => onNavigate(tab.id)}
        >
          {tab.icon}
          <span>{tab.label}</span>
        </button>
      ))}
    </nav>
  )
}
